export default __webpack_public_path__ + "static/media/equip.f6ebfadc.svg";